import { Link } from "react-router";

export default function TermsAndConditions() {
  return (
    <section
      id="terms-and-conditions"
      className="relative  z-10 mx-auto flex  max-w-4xl flex-col    gap-5  px-6 py-24 sm:gap-10"
    >
      <div className="flex flex-col items-center  gap-3 ">
        <p className="eyebrow">legal</p>
        <h1 className="text-center text-5xl">Terms and Conditions</h1>
        <p className=" text-center text-black/65">Updated Sept. 04, 2026</p>
      </div>

      <article className="space-y-5  text-[#3b3e45]">
        <p className="text-base">
          These terms are an agreement between you and Kodelle Inc., the company
          that operates Sakeena. They apply to the Sakeena app, the sakeena.io
          website, and to anyone who submits a vouch through a link we provide.
        </p>
        <p className="text-base">
          By creating an account, using Sakeena, or submitting a vouch, you
          agree to these terms.
        </p>
        <p className="text-base">
          These terms and our{" "}
          <Link to="/privacy-policy" className="text-[#6e7ce6]">
            privacy policy
          </Link>{" "}
          together form the agreement between you and Kodelle. Neither replaces
          the other. Anything concerning your personal information is governed
          by the privacy policy.
        </p>
        <div className="space-y-2 rounded-2xl bg-[#f0f1f7] px-6 py-5">
          <p>
            <span className="font-semibold">Address:</span> 1536 Day Terr,
            Milton, ON, L9E 1H9, Canada
          </p>
          <p>
            <span className="font-semibold">Contact:</span>{" "}
            <a
              href="mailto:support@sakeena.io"
              target="_blank"
              className="text-[#6e7ce6]"
            >
              support@sakeena.io
            </a>
          </p>
        </div>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">1. Who can use Sakeena</h2>
        <p className="text-base">To hold an account you must:</p>
        <ul className="space-y-2">
          <li>be 18 or over;</li>
          <li>be Muslim;</li>
          <li>be using Sakeena to seek marriage, and for no other purpose;</li>
          <li>
            not currently be married. If you are separated, you may not use
            Sakeena until your divorce is final.
          </li>
        </ul>
        <p className="text-base">Divorced and widowed people are welcome.</p>
        <p className="text-base">
          Sakeena is not a dating service and may not be used to arrange
          anything other than marriage. You may not use Sakeena to seek an
          additional spouse while married.
        </p>
        <p className="text-base">
          Matchmakers, marriage bureaus, and anyone acting as an intermediary
          for others may not hold an account. We remove such accounts when we
          find them.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">2. Accepting your application</h2>
        <p className="text-base">
          Creating a profile does not entitle you to an account. We review
          applications and decide whether to accept them.
        </p>
        <p className="text-base">
          We may refuse an application at our sole discretion and without giving
          a reason, including where we believe the information provided is
          untrue, where a person appears to be misrepresenting themselves, or
          where we believe they are not on Sakeena to seek marriage.
        </p>
        <p className="text-base">
          If your application is refused you may contact{" "}
          <a
            href="mailto:support@sakeena.io"
            target="_blank"
            className="text-[#6e7ce6]"
          >
            support@sakeena.io
          </a>
          .
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">3. Your account</h2>
        <p className="text-base">
          You sign in using a one-time code sent to your email address or your
          phone. Sakeena does not use passwords.
        </p>
        <p className="text-base">
          You are responsible for keeping access to the email address and phone
          number on your account, and for anything done through your account.
          Tell us immediately at{" "}
          <a
            href="mailto:support@sakeena.io"
            target="_blank"
            className="text-[#6e7ce6]"
          >
            support@sakeena.io
          </a>{" "}
          if you believe someone else has obtained access to it.
        </p>
        <p className="text-base">
          Everything you enter on your profile must be true, current, and about
          you. You must update it if it stops being accurate.
        </p>
        <p className="text-base">
          Photographs on your profile must be of you, taken within the last
          year, and must show you clearly enough to be recognised.
        </p>
        <p className="text-base">
          You may hold only one account. Creating a second account, or creating
          an account after we have removed a previous one, is a breach of these
          terms.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">4. Profiles created by a guardian</h2>
        <p className="text-base">
          A parent, guardian, or family member may create and hold an account on
          behalf of the person whose profile it is.
        </p>
        <p className="text-base">
          If you do this, you are the account holder and these terms apply to
          you. You confirm that the person whose profile it is:
        </p>
        <ul className="space-y-2">
          <li>is 18 or over and meets the requirements in section 1;</li>
          <li>knows the profile exists and has agreed to it;</li>
          <li>
            has agreed to their information and photographs being published on
            Sakeena; and
          </li>
          <li>was present with you to complete photograph verification.</li>
        </ul>
        <p className="text-base">
          You are responsible for the accuracy of everything on that profile and
          for all activity on the account. If any of the confirmations above
          turns out to be untrue, you agree to cover any loss or claim that
          results.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">5. How you may behave on Sakeena</h2>
        <p className="text-base">You may not:</p>
        <ul className="space-y-2">
          <li>
            give false, misleading, or outdated information on your profile, in
            a post, or in a message;
          </li>
          <li>
            use photographs that are not of you, or that you do not have the
            right to use;
          </li>
          <li>
            post or send anything obscene, sexually explicit, or containing
            nudity;
          </li>
          <li>
            post or send profanity, abusive language, threats, or harassment;
          </li>
          <li>
            post or send anything hateful or discriminatory, or anything that
            incites harm;
          </li>
          <li>continue contacting a member who has asked you to stop;</li>
          <li>
            ask any member for money, investment, or financial assistance;
          </li>
          <li>promote a business, product, service, or cause;</li>
          <li>act as a matchmaker or intermediary for anyone else;</li>
          <li>
            use Sakeena while married, or while a separation is not yet final;
          </li>
          <li>
            seek anything other than marriage, including dating or casual
            contact;
          </li>
          <li>seek or offer a marriage arranged for immigration purposes;</li>
          <li>
            share, publish, or redistribute another member's photographs, posts,
            messages, or vouches outside Sakeena;
          </li>
          <li>
            attempt to defeat or work around the measures that prevent screen
            capture;
          </li>
          <li>
            create more than one account, or create an account after we have
            removed one;
          </li>
          <li>impersonate anyone, including a member of our team;</li>
          <li>
            collect information about members, whether manually or by automated
            means;
          </li>
          <li>use Sakeena to send commercial messages to members;</li>
          <li>
            interfere with Sakeena, its servers, or its security, or attempt to
            gain access you have not been given;
          </li>
          <li>do anything unlawful.</li>
        </ul>
        <p className="text-base">
          We may remove your account permanently for any of the above. Where we
          do, you are not entitled to a refund from us.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">6. Content you put on Sakeena</h2>
        <p className="text-base">
          You keep ownership of what you write and the photographs you upload.
        </p>
        <p className="text-base">
          You give Kodelle permission to store, display, and distribute your
          content so that Sakeena can operate, and to use it in material
          promoting Sakeena. Where we use your content to promote Sakeena, we
          conceal the name of the person who wrote it and remove details that
          would identify anyone.
        </p>
        <p className="text-base">
          This permission ends when the content is deleted, except for material
          already used in promotion, which we cannot recall.
        </p>
        <p className="text-base">
          You confirm that you have the right to everything you put on Sakeena,
          and that it does not infringe anyone else's rights.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">7. Review of content</h2>
        <p className="text-base">
          Profiles, posts, and vouches are reviewed before they are published.
          Review may be automated or carried out by a person.
        </p>
        <p className="text-base">
          Review checks whether content meets these terms. It is not a check on
          whether content is accurate, honest, or credible, and it is not a
          judgment about any member's character or intentions. Review is not
          exhaustive and will not catch everything.
        </p>
        <p className="text-base">
          We may decline to publish anything, and we may remove anything already
          published, at our discretion.
        </p>
        <p className="text-base">
          Nothing on Sakeena is verified by us as true. You are responsible for
          your own judgment about the people you meet and the information they
          give you.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">8. Vouches</h2>
        <p className="text-base">
          A vouch is a written statement about a member, submitted by someone
          who knows them.
        </p>
        <p className="text-base">
          Vouches published about you appear on your profile and are visible to
          other members, along with the name and stated relationship of the
          person who wrote them.
        </p>
        <p className="text-base">
          Vouches cannot be edited or withdrawn from within Sakeena. If you want
          a vouch about you removed, write to{" "}
          <a
            href="mailto:support@sakeena.io"
            target="_blank"
            className="text-[#6e7ce6]"
          >
            support@sakeena.io
          </a>
          .
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">
          9. If you submit a vouch and do not have an account
        </h2>
        <p className="text-base">
          This section applies to you if you write a vouch through a link a
          member sent you.
        </p>
        <p className="text-base">
          By submitting a vouch you agree to these terms, and you confirm that:
        </p>
        <ul className="space-y-2">
          <li>what you have written is true and is your own;</li>
          <li>
            you understand it will be published on that person's profile and
            visible to other members;
          </li>
          <li>
            you understand your name and your stated relationship to them will
            be published alongside it.
          </li>
        </ul>
        <p className="text-base">
          You give Kodelle the same permission described in section 6, including
          use in material promoting Sakeena with your name concealed and
          identifying details removed.
        </p>
        <p className="text-base">
          If you want your vouch removed, write to{" "}
          <a
            href="mailto:support@sakeena.io"
            target="_blank"
            className="text-[#6e7ce6]"
          >
            support@sakeena.io
          </a>
          .
        </p>
        <p className="text-base">
          We may decline to publish a vouch, or remove one, at our discretion.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">10. Connections and blocking</h2>
        <p className="text-base">
          Members can send and receive connection requests. A connection begins
          when a request is accepted.
        </p>
        <p className="text-base">
          <span className="font-semibold">
            Ending a connection is permanent.
          </span>{" "}
          When a connection is removed, both members are blocked from one
          another. This cannot be reversed, by you or by us. Please be certain
          before you remove a connection.
        </p>
        <p className="text-base">
          You can block any member at any time. Blocking is permanent.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">11. Reporting, and contesting a decision</h2>
        <p className="text-base">
          You can report a post or a profile, and you can block a member, from
          within Sakeena. We review reports and take the action we consider
          appropriate, which may include removing content or removing an
          account.
        </p>
        <p className="text-base">
          If we restrict or remove your account, you can write to{" "}
          <a
            href="mailto:support@sakeena.io"
            target="_blank"
            className="text-[#6e7ce6]"
          >
            support@sakeena.io
          </a>{" "}
          and we will review the decision.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">12. We do not screen members</h2>
        <p className="text-base">
          <span className="font-semibold">
            We do not carry out criminal background checks, identity checks
            against public records, or any other screening of members'
            histories.
          </span>{" "}
          Photograph verification confirms only that the photographs on a
          profile are of the same person. It does not confirm anyone's identity,
          character, marital status, or intentions.
        </p>
        <p className="text-base">
          Everything on a profile is what the member told us. Please take the
          same care you would with anyone you have not met.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">13. Subscriptions and payment</h2>
        <p className="text-base">
          Sakeena can be used without paying. Some features require a
          subscription.
        </p>
        <p className="text-base">
          Subscriptions are sold and managed by Apple through the App Store, or
          by Google through Google Play, depending on where you downloaded
          Sakeena. Kodelle does not process payments and does not hold your
          payment details.
        </p>
        <p className="text-base">
          Subscriptions renew automatically at the end of each period unless you
          cancel at least 24 hours beforehand. Price and renewal terms are shown
          before you purchase.
        </p>
        <p className="text-base">
          To cancel, change, or ask about a refund, use your Apple or Google
          account settings. Refunds are decided by Apple or Google under their
          own terms. We cannot cancel a subscription or issue a refund on their
          behalf.
        </p>
        <p className="text-base">
          Cancelling a subscription does not delete your account. Deleting your
          account does not cancel a subscription. If you want both, cancel with
          Apple or Google first.
        </p>
        <p className="text-base">
          We may change our plans and pricing. Changes do not affect a
          subscription period you have already paid for.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">14. Deleting your account</h2>
        <p className="text-base">
          You can delete your account in Sakeena. Your profile is hidden from
          all members immediately, and your information is permanently deleted
          90 days later. Signing in within those 90 days restores your account.
        </p>
        <p className="text-base">
          If you hold a subscription, cancel it with Apple or Google before
          deleting your account. We cannot do this for you, and a subscription
          you do not cancel will continue to be charged.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">15. Sakeena itself</h2>
        <p className="text-base">
          Sakeena, including its software, design, text, and branding, belongs
          to Kodelle Inc. and is protected by copyright and other laws. Nothing
          in these terms gives you any right to it beyond using Sakeena as
          intended.
        </p>
        <p className="text-base">
          You may not copy, modify, reverse engineer, decompile, or create
          anything derived from Sakeena, and you may not extract or reuse any
          part of it.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">16. Sakeena is provided as it is</h2>
        <p className="text-base">
          Sakeena is provided on an "as is" and "as available" basis. We do not
          promise that it will be uninterrupted, error free, or secure, or that
          it will produce any particular outcome for you.
        </p>
        <p className="text-base">
          To the fullest extent the law allows, we exclude all warranties that
          are not expressly stated in these terms.
        </p>
        <p className="text-base">
          Sakeena includes measures intended to prevent screen capture of
          profiles and photographs. These raise the effort required to capture
          what you share. They do not make it impossible, and we do not promise
          that your content cannot be captured.
        </p>
        <p className="text-base">
          We may add, change, or withdraw features at any time, and we may stop
          offering Sakeena altogether. Where a change materially reduces what a
          paid subscription gives you, we will tell you beforehand.
        </p>
        <p className="text-base">
          We are not responsible for storing your content indefinitely and we do
          not promise that it cannot be lost. Please keep your own copy of
          anything you would not want to lose.
        </p>
        <p className="text-base">
          Sakeena may link to websites and services operated by others. We do
          not control them and are not responsible for them.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">17. What we are not responsible for</h2>
        <p className="text-base">
          Members are responsible for their own conduct. We do not vet members
          beyond what is described in section 12, and we are not responsible for
          what any member says or does, on Sakeena or after they leave it.
        </p>
        <p className="text-base">
          To the fullest extent the law allows, Kodelle Inc. is not liable for
          indirect, incidental, special, or consequential loss, or for lost
          profits or lost opportunity, arising from your use of Sakeena.
        </p>
        <p className="text-base">
          Where we are found liable, our total liability to you is limited to
          the amount you paid for Sakeena in the 12 months before the claim
          arose. Where nothing was paid, our liability is limited to the fullest
          extent the law allows.
        </p>
        <p className="text-base">
          Nothing in these terms excludes liability that cannot be excluded by
          law, and nothing affects any right you have under consumer protection
          law where you live.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">18. Covering our costs</h2>
        <p className="text-base">
          If someone brings a claim against Kodelle because of something you did
          on Sakeena, or because you broke these terms, you agree to cover our
          reasonable costs in dealing with it, including legal fees.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">19. Ending your use of Sakeena</h2>
        <p className="text-base">
          You can stop using Sakeena at any time by deleting your account.
        </p>
        <p className="text-base">
          We may suspend or permanently remove your account where you break
          these terms, where we believe you are misrepresenting yourself, or
          where we consider it necessary to protect other members. Where we do
          this you are not entitled to a refund from us, and any subscription
          you hold must still be cancelled with Apple or Google.
        </p>
        <p className="text-base">
          Sections 6, 16, 17, 18, and 20 continue to apply after your account
          ends.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">20. Governing law</h2>
        <p className="text-base">
          These terms are governed by the laws of the Province of Ontario and
          the federal laws of Canada that apply there. Any dispute will be dealt
          with by the courts of Ontario, and you and Kodelle agree to their
          exclusive jurisdiction.
        </p>
        <p className="text-base">
          This does not remove any right you have to bring a claim in the courts
          of the country where you live, where the law of that country gives you
          that right.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">21. Changes to these terms</h2>
        <p className="text-base">
          We may update these terms. Where a change is material we will tell you
          before it takes effect. Other changes take effect when posted.
          Continuing to use Sakeena after a change means you accept it.
        </p>
        <p className="text-base">
          The date at the top is the date of the current version.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">22. General</h2>
        <p className="text-base">
          If part of these terms is found to be unenforceable, the rest
          continues to apply.
        </p>
        <p className="text-base">
          If we do not enforce part of these terms, that does not mean we have
          given up the right to do so later.
        </p>
        <p className="text-base">
          You may not transfer your account or your rights under these terms to
          anyone else. We may transfer this agreement to another company,
          including as part of a sale of our business, and we will tell you if
          we do.
        </p>
        <p className="text-base">
          If you send us a suggestion about Sakeena, we may use it without owing
          you anything for it.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">
          23. If you downloaded Sakeena from the App Store
        </h2>
        <p className="text-base">
          This section applies where you obtained Sakeena through Apple's App
          Store, and it applies only to the extent Apple requires.
        </p>
        <ul className="space-y-2">
          <li>
            This agreement is between you and Kodelle Inc. It is not with Apple,
            and Apple is not responsible for Sakeena or its content.
          </li>
          <li>
            Apple has no obligation to provide any support or maintenance for
            Sakeena.
          </li>
          <li>
            If Sakeena fails to conform to any applicable warranty, you may
            notify Apple and Apple will refund what you paid for it. To the
            fullest extent the law allows, Apple has no other warranty
            obligation, and any other claim arising from a failure to conform to
            a warranty is ours to answer.
          </li>
          <li>
            Kodelle, not Apple, is responsible for addressing any claim about
            Sakeena, including product liability claims, claims that Sakeena
            does not meet a legal requirement, and claims under consumer
            protection law.
          </li>
          <li>
            Kodelle, not Apple, is responsible for investigating and resolving
            any claim that Sakeena infringes someone's intellectual property
            rights.
          </li>
          <li>
            You confirm that you are not located in a country subject to a
            United States government embargo, and that you are not on any United
            States government list of prohibited or restricted parties.
          </li>
          <li>
            Apple and its subsidiaries are third party beneficiaries of these
            terms and may enforce them against you.
          </li>
        </ul>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">24. Contact</h2>
        <div className="space-y-2 rounded-2xl bg-[#f0f1f7] px-6 py-5">
          <p className="font-semibold">Kodelle Inc.</p>
          <p>
            Email:{" "}
            <a
              href="mailto:support@sakeena.io"
              target="_blank"
              className="text-[#6e7ce6]"
            >
              support@sakeena.io
            </a>
          </p>
          <p>Address: 1536 Day Terr, Milton, ON, L9E 1H9, Canada</p>
          <p>
            Website:{" "}
            <a
              href="https://www.sakeena.io"
              target="_blank"
              className="text-[#6e7ce6]"
            >
              https://www.sakeena.io
            </a>
          </p>
        </div>
      </article>

      <hr className=" text-gray-300" />
    </section>
  );
}
